// Preserve an explicit studio selection while retaining the existing default.
export function normalizeSearchBedrooms(value) {
    if (value === null || value === undefined || value === '') return 1;
    const bedrooms = Number(value);
    return Number.isFinite(bedrooms) ? Math.max(0, Math.trunc(bedrooms)) : 1;
}
